import { eventMarkersAtom, unwrappedEventMarkersAtom } from '@/atoms/queries/eventData';
import { HeatMap } from '@/components/visualisations/HeatMap';
import { PitchVisComponentProps } from '@/types/visualisation';

export const DataLockerHeatMap = ({ allowInteraction }: PitchVisComponentProps) => (
  <HeatMap
    pitchEventsAtom={eventMarkersAtom}
    unwrappedPitchEventsAtom={unwrappedEventMarkersAtom}
    allowInteraction={allowInteraction}
  />
);
